import { QqModel } from "../../model/qq.model";
import { CHECKBOX_CHANGED_ACTION, QqActionType } from "../qq-action.type";

export const checkboxAction: (qq: QqModel, checked: boolean) => QqActionType = (
  qq,
  checked
) => {
  return {
    type: CHECKBOX_CHANGED_ACTION,
    data: {
      qq,
      checked,
    },
  };
};
